interface LetterGroup {
  letter: string;
  count: number;
}

interface LetterFilterBarProps {
  groups: LetterGroup[];
  activeLetter: string | null;
  total: number;
  onSelect: (letter: string | null) => void;
}

export default function LetterFilterBar({
  groups,
  activeLetter,
  total,
  onSelect,
}: LetterFilterBarProps) {
  return (
    <nav
      aria-label="Filter featured listings by starting letter"
      className="sticky top-[72px] z-40 border-y border-background-200 bg-background-50/95 backdrop-blur md:top-[116px]"
    >
      <div className="mx-auto flex max-w-[1400px] flex-wrap items-center gap-1.5 px-4 py-3 md:px-6">
        <span className="mr-1 hidden text-xs font-semibold uppercase tracking-wide text-foreground-500 lg:inline">
          Filter by letter
        </span>

        <button
          type="button"
          onClick={() => onSelect(null)}
          aria-pressed={activeLetter === null}
          className={`flex h-8 cursor-pointer items-center justify-center rounded-md px-3 text-xs font-bold uppercase tracking-wide transition-colors duration-200 ${
            activeLetter === null
              ? "bg-primary-500 text-background-50"
              : "bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900"
          }`}
        >
          All
          <span
            className={`ml-1.5 rounded-full px-1.5 text-[10px] font-bold ${
              activeLetter === null
                ? "bg-background-50/25 text-background-50"
                : "bg-background-200 text-foreground-600"
            }`}
          >
            {total}
          </span>
        </button>

        {groups.map((group) => {
          const disabled = group.count === 0;
          const isActive = activeLetter === group.letter;
          return (
            <button
              key={group.letter}
              type="button"
              disabled={disabled}
              onClick={() => onSelect(group.letter)}
              aria-pressed={isActive}
              aria-label={`Show featured listings starting with ${group.letter}`}
              className={`flex h-8 min-w-8 items-center justify-center gap-1 rounded-md px-2 text-xs font-bold uppercase transition-colors duration-200 ${
                disabled
                  ? "cursor-not-allowed bg-background-100/60 text-foreground-300"
                  : isActive
                    ? "cursor-pointer bg-primary-500 text-background-50"
                    : "cursor-pointer bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900"
              }`}
            >
              {group.letter}
              {!disabled ? (
                <span
                  className={`rounded-full px-1.5 text-[10px] font-bold ${
                    isActive
                      ? "bg-background-50/25 text-background-50"
                      : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {group.count}
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    </nav>
  );
}